import React from 'react';

import {
    Text,
    Flex,
    Menu,
    MenuItem,
    MenuPopper,
} from '@zillow/constellation';

import { RMWContext } from 'app/shared/providers/RMWContext';

import pathsManifest from 'app/shared/pathsManifest';

import stringHelper from 'app/shared/utils/stringHelper';

// components
import PropertyStatus from 'app/shared/components/soh/PropertyStatus';

// styled components
import {
    StyledContainer,
    StyledPropertyPhotoContainer,
    StyledPropertyCol,
    StyledPropertyAddress,
} from './StyledComponents';

const PropertyRow = (props) => {
    const getContext = () => RMWContext.Consumer._currentValue;
    const { listing } = props;

    const {
        photoUrl: primaryPhotoUrl,
        status,
        address,
        aliasEncoded,
        isMultifamily,
        name,
        feedName,
        feedId,
        panels,
        productTypes,
        hasBoost,
    } = listing;

    const { code, message: statusMessage } = status;

    const {
        city,
        state,
        street,
        unit,
    } = address;

    const fullAddress = unit ? `${street} ${unit}` : street;

    const handleRowClick = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const { brand } = getContext();
        const paths = pathsManifest.getAllPaths(brand);
        const { propertiesPage } = paths;
        const listingPagePath = `${propertiesPage}/${aliasEncoded}/listing`;

        window.router.transitionTo(listingPagePath);
    };

    const handleMenuClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const menu = (
        <Menu>
            {panels.map((item, index) => (
                <MenuItem
                    key={index}
                    onClick={() => window.router.updateLocation(item.urlPath)}
                >
                    {item.title}
                </MenuItem>
            ))}
        </Menu>
    );

    return (
        <StyledContainer onClick={handleRowClick}>
            <StyledPropertyCol xs={2}>
                <StyledPropertyPhotoContainer primaryPhotoUrl={primaryPhotoUrl} />
            </StyledPropertyCol>
            <StyledPropertyCol xs={3}>
                <PropertyStatus
                    code={code}
                    message={statusMessage}
                />
                <StyledPropertyAddress>
                    <Flex flex="1">
                        <Text>
                            <strong>{isMultifamily ? name : fullAddress}</strong>
                        </Text>
                    </Flex>
                    <div>
                        <Text>
                            {isMultifamily ? fullAddress : null}
                        </Text>
                    </div>
                </StyledPropertyAddress>
            </StyledPropertyCol>
            <StyledPropertyCol xs={1}>
                <Text>{stringHelper.wrapText(city, 25)}</Text>
            </StyledPropertyCol>
            <StyledPropertyCol xs={1}>
                <Text>{state}</Text>
            </StyledPropertyCol>
            <StyledPropertyCol xs={1}>
                <Text>{stringHelper.wrapText(feedName || feedId, 25)}</Text>
            </StyledPropertyCol>
            <StyledPropertyCol xs={2}>
                {productTypes.length > 0
                    ? productTypes.map((productType, index) => <Text key={index}>{productType}</Text>)
                    : '-'
                }
            </StyledPropertyCol>
            <StyledPropertyCol xs={1}>
                <Text>{hasBoost ? 'Boost' : '-'}</Text>
            </StyledPropertyCol>
            <StyledPropertyCol xs={1} onClick={handleMenuClick} alignEnd={true}>
                <MenuPopper triggered={menu} />
            </StyledPropertyCol>
        </StyledContainer>
    );
};

PropertyRow.propTypes = {};
PropertyRow.defaultProps = {};

export { PropertyRow };
export default PropertyRow;
